import { Link } from 'react-router-dom';
import { mangaList, hotMangaIds } from '@/mocks/manga';

export default function HotMangaSection() {
  const hotManga = hotMangaIds
    .map((id) => mangaList.find((m) => m.id === id))
    .filter(Boolean) as typeof mangaList;

  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            <strong>热门韩漫</strong>推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">最受欢迎的韩国漫画，大家都在看</p>
        </div>
        <Link
          to="/category/all"
          className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
        >
          查看全部 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop>
        {hotManga.map((manga) => (
          <Link
            key={manga.id}
            to={`/article/${manga.id}`}
            className="group cursor-pointer"
          >
            <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
              <img
                src={manga.cover}
                alt={manga.title}
                title={`${manga.title} - 韩漫漫画网`}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-2 left-2 right-2">
                <span className="inline-block px-2 py-0.5 bg-primary-500 text-white text-xs rounded-full">
                  {manga.rating}
                </span>
              </div>
              {manga.status === '连载中' && (
                <div className="absolute top-2 right-2">
                  <span className="inline-block px-2 py-0.5 bg-accent-500 text-white text-xs rounded-full">
                    连载中
                  </span>
                </div>
              )}
            </div>
            <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1">
              {manga.title}
            </h3>
            <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{manga.author}</p>
          </Link>
        ))}
      </div>
    </section>
  );
}